import { SetStateAction, Dispatch, useState, useEffect } from 'react';
import { useCountDown } from 'ahooks';
import styled from './index.module.scss';
import { useLang } from '@/i18n';

const CouponExpired = ({ timeStamp, closeTip }: { timeStamp: number; closeTip?: Dispatch<SetStateAction<boolean>> }) => {
    const { t } = useLang('membersstore');
    const [isVisible, setIsVisible] = useState(true);

    const [, formattedRes] = useCountDown({
        targetDate: timeStamp,
        onEnd: () => {
            closeTip && closeTip(false);
        },
    });
    const { hours, minutes, seconds } = formattedRes;

    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    useEffect(() => {
        const handleScroll = () => {
            const { scrollHeight, scrollTop, clientHeight } = document.documentElement;
            const isAtBottom = scrollHeight - scrollTop === clientHeight;
            setIsVisible(!isAtBottom);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return isVisible ? (
        <div className={styled.CouponExpired}>
            <div className="content">
                <span>{t('expiredCode')}</span>
                <div className="content-digitals">
                    <div className="time">{handleCompletion(hours)}</div>
                    <span className="colon">{t('colon.hours')}</span>
                    <div className="time">{handleCompletion(minutes)}</div>
                    <span className="colon">{t('colon.minutes')}</span>
                    <div className="time">{handleCompletion(seconds)}</div>
                    <span className="colon">{t('colon.seconds')}</span>
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default CouponExpired;
